import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_Datatypes = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      title="Data Types in C"
      videos={[
        "https://www.youtube.com/embed/GHsgu3Rolys", // DataTypes in C
      ]}
      takeaways={[
        {
          text: "Remember different types of data types in C and their syntax for declaration.",
        },
      ]}
      questions={[
        "What are the different types of data types in C? Provide examples.",
        "What is the difference between primary and secondary data types?",
      ]}
      exampleVideos={[]} // No extra example videos for now
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default OOPS_M1_Datatypes;
